import { useNavigate } from 'react-router-dom';

interface ResourceLink {
  label: string;
  slug?: string;
  path?: string;
}

export default function Footer() {
  const navigate = useNavigate();

  const resourceLinks: ResourceLink[] = [
    { label: 'Home', path: '/' },
    { label: 'Spreadsheet Guide', slug: 'vigorbuy-spreadsheet-guide' },
    { label: 'Sneaker Guide', slug: 'vigorbuy-sneaker-guide' },
    { label: 'Safety Guide', slug: 'vigorbuy-safety-guide' },
    { label: 'Shipping Tips', slug: 'vigorbuy-shipping-tips' },
  ];

  const quickLinks = [
    { label: 'VigorBuy Sheet', url: 'https://kaspreadsheet.com' },
    { label: 'Buy It Now', url: 'https://kaspreadsheet.com' },
    { label: 'Shoes Category', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies Category', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <h3 className="font-heading text-3xl md:text-4xl font-extrabold tracking-tight mb-6">VIGORBUY</h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              An independent resource center providing verified VigorBuy spreadsheet links, buying guides, and shopping tutorials. Not affiliated with or endorsed by any official shopping platform. All external links are provided for informational purposes only.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {['ri-twitter-x-line', 'ri-discord-line', 'ri-reddit-line', 'ri-instagram-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                  aria-label="Social media"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-4">Resources</p>
            <ul className="space-y-2.5">
              {resourceLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.slug ? `/article/${item.slug}` : (item.path || '/')}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      if (item.slug) {
                        navigate(`/article/${item.slug}`);
                      } else {
                        navigate(item.path || '/');
                      }
                      window.scrollTo(0, 0);
                    }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-4">Quick Links</p>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800 px-6 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 VigorBuy.skin — Independent Buying Resource
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">Disclaimer</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">Privacy</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}